import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { LanguageProvider } from './contexts/LanguageContext';
import Home from './pages/Home';
import CurrencyConverter from './pages/CurrencyConverter';
import VolumeConverter from './pages/VolumeConverter';
import LengthConverter from './pages/LengthConverter';
import WeightConverter from './pages/WeightConverter';
import TemperatureConverter from './pages/TemperatureConverter';
import TimeZoneConverter from './pages/TimeZoneConverter';
import Mp4ToMp3Converter from './pages/Mp4ToMp3Converter';
import ImageToPdfConverter from './pages/ImageToPdfConverter';
import PngToJpgConverter from './pages/PngToJpgConverter';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/currency" element={<CurrencyConverter />} />
            <Route path="/volume" element={<VolumeConverter />} />
            <Route path="/length" element={<LengthConverter />} />
            <Route path="/weight" element={<WeightConverter />} />
            <Route path="/temperature" element={<TemperatureConverter />} />
            <Route path="/timezone" element={<TimeZoneConverter />} />
            <Route path="/mp4-to-mp3" element={<Mp4ToMp3Converter />} />
            <Route path="/image-to-pdf" element={<ImageToPdfConverter />} />
            <Route path="/png-to-jpg" element={<PngToJpgConverter />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
 